import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'reflexbox';

const DarkerBox = props => (
  <Box
    m={0}
    {...props}
    style={{
      backgroundColor: '#292929',
      padding: 15,
      borderRadius: '10px',
      ...props.style,
    }}
  >
    {props.children}
  </Box>
);

DarkerBox.propTypes = {
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  children: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
};

DarkerBox.defaultProps = {
  style: {},
};

export default DarkerBox;
